import type { PayrollPrices } from './payrollPrice.selectors'

export const describeBaseAndPerPersonCost = ({
  base,
  seat,
}: PayrollPrices): string =>
  base && seat
    ? `a base cost of ${base}/month + ${seat}/individual per month`
    : 'a monthly base cost + a monthly cost per individual'
